import { Container } from '@cleartrip/ct-design-components'
import { Stencil } from '@/components/common/Stencil'
import React, { memo } from 'react'
import { INTL_ONEWAY_TUPPLE_WIDTH } from '@/constants/Srp'

const LoaderCard = memo(() => (
    <Container className="mb-4" >
        <Container 
            className="br-12 pt-3 pb-3 px-3 ba-solid" 
            css={{ 
                borderColor: '#e6e6e6',
                backgroundColor: '#ffffff',
                width: INTL_ONEWAY_TUPPLE_WIDTH,
                height: '147px'
            }}
        >
            <Container className="mb-3 br-4">
                <Stencil shimmer className="br-2" height="20px"  />
            </Container>
            
            <Container className="mb-3">
                <Stencil shimmer className="br-8" height="52px"  />
            </Container>
            
            <Container>
                <Stencil shimmer className="br-4" height="20px"  />
            </Container>
        </Container>
    </Container>
))

function IntlOneWayTripTuppleLoader() {
    return (
        <Container className="flex flex-col mt-6">
            <Container className="w-50p">
                <LoaderCard />
                <LoaderCard />
                <LoaderCard />
            </Container>
        </Container>
    )
}

export default IntlOneWayTripTuppleLoader
